<template>
  <fragment>
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item to="planner">
          <v-list-item-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Planner</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="profiles">
          <v-list-item-action>
            <v-icon>mdi-face-profile</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Profiles</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="setting">
          <v-list-item-action>
            <v-icon>mdi-account-settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
      
      </v-toolbar-title>
      <!-- <v-toolbar-title><v-row
                row
              ><v-avatar
                  size="36px"
                >
                  <img
                    :src="profile.profilePicture"
                  >
                </v-avatar>
                <p>hello</p>
      </v-row>-->
      <!-- </v-toolbar-title> -->
      <v-col class="d-flex" cols="12" sm="6"></v-col>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </fragment>
</template>

<script>
import { LOGOUT } from '../store/actions.type';

export default {
  props: {
    source: String,
  },
  components: {
  },
  data: () => ({
    // profiles: [
    //   {
    //     name: 'Toth Zoltan',
    //     profilePicture:
    //       'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
    //   },
    //   {
    //     name: 'Trab Antal',
    //     profilePicture:
    //       'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
    //   },
    // ],
    drawer: false,
  }),
  computed: {
    profiles() {
      return ['Arial', 'Calibri', 'Courier', 'Verdana'];
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT);
    },
  },
};
</script>

<style>
</style>
